import { Container } from '@mui/material'
import React from 'react'
import { DealershipsTable } from '../../components/data/dealership/DealershipsTable'

const Dealerships = () => {
  return (
    <Container maxWidth='xl' sx={{ p: 2, maxWidth: '100vw' }}>
      <DealershipsTable />
    </Container>
  )
}

export default Dealerships
